import React, { Component } from 'react'
import { NotificationManager, NotificationContainer } from 'react-notifications'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import IntlMessages from 'util/IntlMessages'
import { Button } from 'reactstrap'
import Logo from 'assets/images/logo.jpg'

import {
  REGISTER_USER
} from 'constants/actionTypes'
import { createUnrestrictedAction } from 'util/actionCreators'

class Register extends Component {
  constructor (props) {
    super(props)

    this.state = {
      name: '',
      email: '',
      password: ''
    }
  }

  handleChange (event) {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleSubmit () {
    this.props.createUnrestrictedAction('users', REGISTER_USER, 'POST', { data: this.state }, (response) => {
      this.props.history.push('/login')
      return (
        NotificationManager.success(
          response.message,
          '',
          3000
        )
      )
    })
  }

  render () {
    const { name, email, password } = this.state
    return (
      <div
        className='app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3'>
        <div className='login-content text-center'>
          <div className='login-header mb-4 text-center'>
            <Link className='app-logo' to='/' title='Majocchi Listino'>
              <img src={Logo} alt='majocchi' title='majocchi' />
            </Link>
          </div>

          <div className='mb-4'>
            <h2><IntlMessages id='appModule.createAccount' /></h2>
          </div>

          <div className='login-form'>
            <div>

              <div className='form-group mb-3'>
                <input type='text' placeholder='Name' name='name' value={name}
                  className='form-control form-control-lg' />
              </div>

              <div className='form-group mb-3'>
                <input type='text' placeholder='Email' name='email' value={email}
                  className='form-control form-control-lg' />
              </div>
              <div className='form-group mb-3'>
                <input type='password' placeholder='Password' name='password' value={password}
                  className='form-control form-control-lg' />
              </div>

              <div className='mb-3'>
                <Button className='btn btn-primary' onClick={this.handleSubmit.bind(this)}>
                  <IntlMessages id='appModule.regsiter' />
                </Button>
              </div>
              <p>
                <IntlMessages id='appModule.hvAccount' />
                <Link to='/login' className='ml-1'>
                  Login
                </Link>
              </p>
            </div>
          </div>
        </div>
        <NotificationContainer />
      </div>
    )
  }
}

export default connect(null, { createUnrestrictedAction })(Register)



// WEBPACK FOOTER //
// ./containers/Register.js